module.exports = __webpack_public_path__ + "img/vessel-ikon.a902b204.png";